import {createSelector} from 'reselect';
import getHasResidentialSavedAddresses from './DeliveryAddressSelectors/getHasResidentialSavedAddresses';
import {getExperiment, getIsInCombinedUXExperiment} from './ExperimentSelectors';
import {getSettings} from './selectors';

export default deliveryType => createSelector(
  [getExperiment, getSettings, getHasResidentialSavedAddresses, getIsInCombinedUXExperiment],
  (experiment, settings, hasSavedAddress, isInCombinedUXExperiment) => (
    settings.should_show_contact_number_after_addressee
    || experiment?.should_show_contact_number_after_addressee_wave_01 === 'v1|should_show_contact_number_after_addressee'
    || isInCombinedUXExperiment
  ) && !hasSavedAddress && deliveryType === 'delivery',
);
